import { usePageContext } from 'application/contexts/PageContext';
import { handleShyHeading } from 'helpers/string/string';
import { HeroCanvasPage } from 'ui/components/3-organisms/Hero/HeroCanvasPage';

export const HeroCanvasFeature: React.FC<Content.HeroCanvas> = ({ content }) => {
	const PageContext = usePageContext();
	const { themeSettings } = PageContext;

	const { image, lead, imageDisableSpacingBottom } = content?.properties ?? {};
	const img: UI.Image = image
		? {
				url: image.url,
				altText: image.alt ?? '',
		  }
		: null;

	return (
		<HeroCanvasPage
			image={img}
			theme={themeSettings?.heroAndBreadcrumbColorTheme}
			heading={handleShyHeading(content?.properties)}
			lead={lead}
			imageDisableSpacingBottom={imageDisableSpacingBottom}
		/>
	);
};
